export default __webpack_public_path__ + "static/media/Logo.3a91f487.svg";